import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { TranslateService } from '../../services/translate.service';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from '@ionic/angular/standalone';
import { ModalController } from '@ionic/angular';
import { SessionService } from '../../services/session.service';
import { Observable } from 'rxjs';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-session-timeout-modal',
  templateUrl: './session-timeout-modal.component.html',
  styleUrls: ['./session-timeout-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslatePipe, IonHeader, IonToolbar, IonTitle, IonContent, IonButton],
})
export class SessionTimeoutModalComponent implements OnInit {
  remainingTime$!: Observable<string>;

  constructor(
    private translateService: TranslateService,
    private modalService: ModalService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.remainingTime$ = this.sessionService.getRemainingTime();
  }

  onContinueSession() {
    this.modalService.dismiss('continue');
  }

  onLogout() {
    this.modalService.dismiss('logout');
  }

  getSessionExpiryMessage(remainingTime: string | null): string {
    const message = this.translateService.instant('SESSION_EXPIRY_MESSAGE');
    return message.replace('{remainingTime}', remainingTime || '0:00');
  }
}